// extracted by mini-css-extract-plugin
export var cruiseEventTagsWrapper = "CruiseRecapColumns-module--cruise-event-tags-wrapper--7bed1";
export var cruiseRecap = "CruiseRecapColumns-module--cruise-recap--b88d3";
export var cruiseRecapAuto = "CruiseRecapColumns-module--cruise-recap-auto--f4bd8";
export var cruiseRecapAutoWide = "CruiseRecapColumns-module--cruise-recap-auto-wide--ec8a7";
export var cruiseRecapGrid = "CruiseRecapColumns-module--cruise-recap-grid--bf684";